<template>
  <div class="view-product-detail">
    <!-- header头 -->
    <div class="header">
      <div class="back-btn" @click="detainmentShow"><img src="@/assets/images/icon-back.png"></div>
      <div class="title">{{detailData.insuranceName || name}}</div>
    </div>

    <!-- 预约专家咨询按钮 -->
    <img
      id="moveDiv"
      src="https://m.health.pingan.com/share/images/explainOrder-v3.png"
      style="position: absolute;top: 20%;right: 0;height: auto;width: 42px;z-index: 97;"
      @click="appointmentTime"
    />

    <!-- 内容区 -->
    <div ref="containerWrapper" class="container" @scroll="scrollHandler">
      <div class="banner">
        <div class="head-image">
          <img :src="detailData.detailImage" />
          <a class="btnBox" @click="goToAnchor(introTabList[0])" data-track="lijitoubaoPic">
            <img :src="detailData.buttonImage">
          </a>
        </div>
      </div>
      <!-- 保障计划 -->
      <InsurePlan :insure-arrange-data="detailData.insuranceArranges" :insurance-id="insuranceId" :page-id="pageId"></InsurePlan>
      <!--福利活动-->
      <div ref="activityWrapper" v-if="activityInfo.length > 0" >
        <Activity :activity-data="activityInfo"></Activity>
      </div>
      <!--产品特色 理赔说明 常见问题切换tab-->
      <div class="intro" :class="{'isFixed': isFixedTab}">
        <ul ref="introTab">
          <li :class="{'active': item.active}" v-for="(item,index) in introTabList" :key="index" @click="goToAnchor(item)">{{item.name}}</li>
        </ul>
      </div>
      <div class="fixPlace" ref="fixPlace" v-if="isFixedTab"></div>
      <!--填写投保信息-->
      <div class="order-form" id="orderFormEl" ref="orderFormWrapper">
        <div class="order-title">填写投保信息</div>
        <!--填写订单步骤-->
        <div class="step-list">
          <!--投保人信息-->
          <div class="step-item">
            <div class="step-title">
              <em>1</em>
              <span>本人信息</span>
              <label>(投保人)</label>
            </div>
            <div class="step-cont">
              <div class="input-item">
                <span>姓名</span>
                <input type="text" v-model="applicant.realName" placeholder="信息保密，仅用于投保"  :disabled="applicant.messageIsModify === '2'" v-on:input="onRealNameChange" v-on:keyup="modifyOldUserName"/>
              </div>
              <div class="input-item">
                <span v-if="applicant.isIdentify === '1'">身份证号码</span>
                <span v-else>证件号码</span>
                <input type="text" maxlength="18" v-model="applicant.idCardNo" placeholder="信息保密，仅用于投保" :disabled="applicant.messageIsModify === '2'" v-on:blur="onApplicantIdCardNoChange($event)" v-on:keyup="modifyOldUserId"/>
              </div>
              <div class="input-item" v-if="applicant.isIdentify === '2' && applicant.messageIsModify === '2'">
                <span>出生日期</span>
                <label class="disabled-label">{{applicant.birthDay}}</label>
              </div>
              <div class="input-item" v-if="applicant.isIdentify === '2' && applicant.messageIsModify === '2'">
                <span>性别</span>
                <label class="disabled-label" v-if="applicant.sex === '1'">男</label>
                <label class="disabled-label" v-else-if="applicant.sex === '2'">女</label>
              </div>
              <div class="input-item">
                <span>手机号码</span>
                <input type="tel" v-model="phone" maxlength="11" placeholder="信息保密，仅用于投保" v-on:input="onPhoneChange" />
              </div>
              <div class="input-item" v-if="showSmsCodeItem">
                <span>验证码</span>
                <input type="tel" v-model="smsCode" maxlength="6" placeholder="请输入验证码" v-on:input="onSmsCodeChange" />
                <div class="get-code" :class="{'disabled': getCodeText !== '获取验证码'}" @click="getSmsCode">{{getCodeText}}</div>
              </div>
            </div>
          </div>
          <!--被保人信息-->
          <div class="step-item">
            <div class="step-title">
              <em>2</em>
              <span>为谁投保</span>
              <label>(被保人)</label>
            </div>
            <div class="step-cont">
              <div class="sel-insurants">
                <ul>
                  <li :class="{'active': insurant.relation === '1'}" @click="selectInsurant('1')">本人</li>
                  <li :class="{'active': insurant.relation === '4'}" @click="selectInsurant('4')">父母</li>
                  <li :class="{'active': insurant.relation === '2'}" @click="selectInsurant('2')">配偶</li>
                  <li :class="{'active': insurant.relation === '3'}" @click="selectInsurant('3')">子女</li>
                </ul>
              </div>
              <div class="input-item" v-if="insurant.relation !== '1'">
                <span>姓名</span>
                <input type="text" v-model="insurant.realName" placeholder="信息保密，仅用于投保" v-on:input="onRealNameChange" />
              </div>
              <div class="input-item" v-if="insurant.relation !== '1'">
                <span>身份证号码</span>
                <input type="text" maxlength="18" v-model="insurant.idCardNo" placeholder="信息保密，仅用于投保" v-on:blur="onInsurantIdCardNoChange($event)" />
              </div>
              <div class="input-item">
                <span>有无社保</span>
                <div class="sel-social-security">
                  <p class="sel-option" :class="{'active': insurant.hasSocialSecurity === '1'}" @click="selectSocialSecurity('1')">有社保(含新农合)</p>
                  <p class="sel-option" :class="{'active': insurant.hasSocialSecurity === '2'}" @click="selectSocialSecurity('2')">无社保</p>
                </div>
              </div>
            </div>
          </div>
          <!--保障计划-->
          <div class="step-item step-item-mt-2">

            <div class="step-title">
              <em>3</em>
              <span>保障计划</span>
              <div class="howBuy" v-if="switchOff" @click="showHouBuyBox = !showHouBuyBox" >不知道怎么买?</div> 
            </div>

            <div class="step-cont">
              <div class="sel-plan">
                <ul>
                  <li class="sel-plan-item" :class="{'active': item.insPlanId === insPlanId}" v-for="(item, index) in detailData.insPlans" :key="index" @click="selectInsPlan(item.insPlanId)">{{item.insPlanName}}</li>
                </ul>
              </div>
            </div>
            <p class="step-disc">*如您或您的家人年龄超过55周岁或者患有多种慢病，请看看我们的 <span @click="goDetail(1)">《i康保·老年医疗(三高版)》</span></p>
            <p class="step-disc">*如果您没有上述疾病，请看看我们的 <span @click="goDetail(2)">《平安e生保2020》</span></p>
          </div>
          <!--附加保障-->
          <div class="step-item">
            <div class="step-title">
              <em>4</em>
              <span>附加保障</span>
              <label>(可选)</label>
            </div>
            <div class="step-cont">
              <div class="duty-list">
                <div class="duty-item" v-for="(item,index) in insuranceDutyDisplays" :key="index">
                  <div class="duty-base-info">
                    <p class="duty-title">
                      <span>{{item.title}}</span>
                      <img src="@/assets/images/icon-tips.png" @click="lookDutyDetail(item.dutyId,item.title,item.ageRange)">
                    </p>
                    <p class="age-range" v-if="item.ageRange"><span>{{item.ageRange}}</span></p>
                    <p class="limit-desc">{{item.limitDesc}}</p>
                  </div>
                  <div class="duty-price">
                    <span>{{item.minPrice.substr(0, item.minPrice.length - 1)}}</span>
                    <label>起</label>
                  </div>
                  <div class="duty-sel" @click="selectInsDuty(item.dutyId)">
                    <img v-if="insDutyIds.includes(item.dutyId)" src="@/assets/images/icon-select-1.png">
                    <img v-else src="@/assets/images/icon-select-0.png">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--投保分支机构选择-->
          <div class="step-item" v-if="1===2">
            <div class="step-organs">
              <div class="step-title">
                <em>5</em>
                <span>投保分支机构</span>
                <img src="@/assets/images/icon-tips.png">
              </div>
              <div class="sel-organs">
                <select>
                  <option>请选择</option>
                </select>
              </div>
            </div>
          </div>
          <!--选择缴费方式-->
          <div class="step-item step-item-pd">
            <div class="step-title">
              <em>5</em>
              <span>缴费方式</span>
            </div>
            <div class="step-cont">
              <div class="sel-pay-mode">
                <ul>
                  <li :class="{'active': item.payMode === paymentType}" v-for="(item, index) in detailData.payModeList" :key="index" @click="selectPayMode(item.payMode)">{{item.payModeTips.split('|')[0]}}<br/>{{item.payModeTips.split('|')[1]}}</li>
                </ul>
              </div>
              <!--月缴信息-->
              <div class="mode-description" v-if="paymentType === 2">
                <div class="selected-mode" @click="showPayChannelPopup">
                  <span class="name">扣款方式</span>
                  <div class="mode-value">
                    <span class="icon"><img :src="payChannelObj.iconUrl"></span>
                    <span class="text" v-if="payChannelObj.code === 3 && bankCardNo">银行卡({{bankCardNo}})</span>
                    <span class="text" v-else>{{payChannelObj.title}}</span>
                    <span class="arrow"><img src="@/assets/images/icon-sel-arrow.png"></span>
                  </div>
                </div>
                <ul class="desc-tips">
                  <li>
                    <span>{{payChannelObj.bindCardMessage}}</span>
                  </li>
                  <li>
                    <span>开通前请仔细阅读</span>
                    <a href="javascript:;" :data-url="payModeMonth.autoRenewalNoticeUrl" @click="goToThirdPage($event)">{{payModeMonth.autoRenewalNotice}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--年缴信息-->
          <div class="step-item step-item-pd" v-if="paymentType === 5">
            <div class="step-auto-renewal">
              <div class="step-title">
                <em>6</em>
                <span>设置自动缴费</span>
              </div>
              <div class="sel-switch">
                <cube-switch v-model="autoRenewal"></cube-switch>
              </div>
            </div>
            <div class="selected-mode" @click="showPayChannelPopup" v-if="autoRenewal">
              <span class="name">扣款方式</span>
              <div class="mode-value">
                <span class="icon"><img :src="payChannelObj.iconUrl"></span>
                <span class="text" v-if="payChannelObj.code === 3 && bankCardNo">银行卡({{bankCardNo}})</span>
                <span class="text" v-else>{{payChannelObj.title}}</span>
                <span class="arrow"><img src="@/assets/images/icon-sel-arrow.png"></span>
              </div>
            </div>
            <div class="step-cont">
              <div class="auto-renewal-desc">
                <ul>
                  <li v-for="(item, index) in payModeYear.autoRenewalDeclaration.split('|')" :key="index">
                    <span>{{item.replace('{%}', '')}}</span>
                    <a href="javascript:;" v-if="item.indexOf('%') != -1" :data-url="payModeYear.autoRenewalNoticeUrl" @click="goToThirdPage($event)">{{payModeYear.autoRenewalNotice}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 我已阅读位置变动 -->
      <div class="protocol" id="adjusted-protocol">
        <div class="agree">
          <img v-if="!isAgreeAllProtocol" src="@/assets/images/icon-select-0.png" @click="isAgreeAllProtocol=true">
          <img v-else-if="isAgreeAllProtocol" src="@/assets/images/icon-select-1.png" @click="isAgreeAllProtocol=false">
          <span>我已阅读并了解</span>
          <a href="javascript:;" :data-url="detailData.insuranceItemUrl" @click="goToThirdPage($event)">《保险条款》</a>
          <a href="javascript:;" :data-url="detailData.immunityUrl" @click="goToThirdPage($event)">《责任免除》</a>
          <a href="javascript:;" :data-url="detailData.declarationUrl" @click="goToThirdPage($event)">《重要声明》</a>
          <a href="javascript:;" :data-url="detailData.applyNoticeUrl" @click="goToThirdPage($event)">《理赔须知》</a>
          <a href="javascript:;" :data-url="detailData.productRateUrl" @click="goToThirdPage($event)">《产品费率》</a>
          <a href="javascript:;" :data-url="detailData.secretPolicyUrl" @click="goToThirdPage($event)">《平安健康隐私政策》</a>
          <span>及以上告知内容</span>
        </div>
      </div>
      <!--产品特色-->
      <div ref="featureWrapper" id="featureEl">
       <Feature></Feature>
      </div>
      <!--理赔说明-->
      <div ref="claimWrapper" id="claimEl">
        <Claim></Claim>
        <Question></Question>
      </div>
      <!--隐私协议-->
      <div class="protocol">
        <div class="desc">{{detailData.residentListUrl}}</div>
        <div class="desc">{{detailData.warmMessage}}</div>
      </div>
      <div class="discount-bar" v-if="isbottomfix && discountObj.show && discountObj.message">
        {{discountObj.message}}
      </div>
      <!--底部价格、立即投保按钮-->
      <div v-if="isbottomfix" class="bottom-fixed" :class="{'is-iphonex': isIphonex}">
        <div class="price" v-if="!discountObj.show">
          <div v-if="price && price.toString().split('|').length > 1">
            <span>{{price.toString().split('|')[0] | formatPrice}}</span>
            <label>{{price.toString().split('|')[1]}}</label>
          </div>
          <div v-else>
            <span v-if="price">{{price.toString().split('|')[0] | formatPrice}}<i>元</i></span>
          </div>
        </div>
        <div class="discount-price" v-else>
          <p class="current-price-str">
            <span>{{discountObj.priceStr}}</span>
          </p>
          <p class="original-price-str">
            <span>{{discountObj.originalPriceStr}}</span>
          </p>
        </div>
        <a class="button" @click="onInsRegister" data-track="lijitoubaoButton">立即投保</a>
      </div>
    </div>
    <!--选择扣款方式弹窗-->
    <cube-popup type="my-popup" position="bottom" :mask-closable="true" ref="selPayChannelPopup" :zIndex="zIndex92">
      <div class="sel-pay-mode-content">
        <div class="title">选择扣款方式</div>
        <div class="pay-mode-list">
          <ul>
            <li v-for="(item, index) in payChannelList" :key="index" @click="selectPayChannel(item)">
              <span class="icon"><img :src="item.iconUrl"></span>
              <div class="cont-wechat" v-if="!item.payInfoTips">
                <span>{{item.title}}</span>
                <label class="rec-tag" v-if="index === 0">推荐</label>
              </div>
              <div class="cont-bank-card" v-else>
                <p class="name">{{item.title}}<label class="rec-tag" v-if="index === 0">推荐</label></p>
                <p class="desc">{{item.payInfoTips}}</p>
              </div>
              <span class="arrow"><img src="@/assets/images/icon-sel-arrow.png"></span>
            </li>
          </ul>
        </div>
        <div class="cancel-btn" @click="hidePayChannelPopup">取消</div>
      </div>
    </cube-popup>
    <!--同意协议弹窗-->
    <cube-popup position="center" ref="agreeProtocolPopup" :zIndex="zIndex100">
      <div class="agree-content">
        <div class="image"><img src="@/assets/images/img-continue.png"></div>
        <div class="protocol-value">
          <span>我已阅读并了解</span>
          <a href="javascript:;" :data-url="detailData.insuranceItemUrl" @click="goToThirdPage($event)">《保险条款》</a>
          <a href="javascript:;" :data-url="detailData.immunityUrl" @click="goToThirdPage($event)">《责任免除》</a>
          <a href="javascript:;" :data-url="detailData.declarationUrl" @click="goToThirdPage($event)">《重要声明》</a>
          <a href="javascript:;" :data-url="detailData.applyNoticeUrl" @click="goToThirdPage($event)">《理赔须知》</a>
          <a href="javascript:;" :data-url="detailData.productRateUrl" @click="goToThirdPage($event)">《产品费率》</a>
          <a href="javascript:;" :data-url="detailData.secretPolicyUrl" @click="goToThirdPage($event)">《平安健康隐私政策》</a>
          <span>及以上告知内容</span>
        </div>
        <div class="agree-btn" @click="goInsRegister">好的，继续</div>
      </div>
      <div class="close-popup" @click="hideAgreeProtocolPopup"><img src="@/assets/images/icon-close-popup.png"></div>
    </cube-popup>
    <!--挽留弹窗-->
    <!-- <cube-popup :mask-closable="true" position="center" @mask-click="continueOK" ref="detainmentPopup" :zIndex="zIndex200">
      <div class="detainment-inner">
        <div class="content-box">
          <p>就差一步即可享受三甲医师</p>
          <p><span>7*24小时</span>视频问诊服务</p>
        </div>
        <div class="continue-ok"><a href="javascript:;" @click.stop="continueOK()">立即投保</a></div>
        <div class="leave-no"><a href="javascript:;" @click.stop="leaveNO()">狠心离开</a></div>
      </div>
    </cube-popup> -->
    <!--加购责任弹窗-->
    <cube-popup :mask-closable="true" @mask-click="closeDutyPopup" ref="dutyPopup" :zIndex="zIndex200">
      <div class="duty-inner">
        <h3>{{insuranceDutyDetail.title}}</h3>
        <h4>{{insuranceDutyDetail.agerange}}</h4>
        <div id="jgzr_contentbox">
          <div v-for="(item,index) in insuranceDutyDetail.frameMessageList" :key="index">
            <div class="sub_title">{{item.frameLowerTitle}}</div>
            <div class="tips_content">{{item.frameContent}}</div>
          </div>
        </div>
        <div class="tips_bottom">
          <a href="javascript:;" @click="closeDutyPopup">我知道了</a>
        </div>
      </div>
    </cube-popup>
    <!--绑卡弹窗-->
    <div ref="bindCardPopup" v-if="bindCardPopup">
      <div class="bind-card-content">
        <bind-card @close="closeBindCardPopup" @bindCardSuccess="bindCardSuccess" :realName="applicant.realName" :phone="phone" :idCardNo="applicant.idCardNo" :userId="applicant.userId"></bind-card>
      </div>
    </div>

    <!-- 预约咨询弹窗 -->
    <consultQuestion
      v-if="showConsultQuestion"
      :secretPolicyUrl="detailData.secretPolicyUrl"
      :insId="insuranceId"
      :userInfoObj="userInfo"
      :flag="flag"
      :showPhoneCode="showPhoneCode"
      :totalInfo="totalInfo"
      @cancleCommit="cancleCommit"
      @toastSuccess="toastSuccess"
    ></consultQuestion>
    <!-- 不知道怎么买弹窗 -->
    <div class="howBuy-box" v-if="showHouBuyBox" >
      <div class="howBuy-mark" @click="showHouBuyBox = !showHouBuyBox"></div>
      <div class="howBuy-cont">
          <i @click="showHouBuyBox = !showHouBuyBox"></i>
          <p class="howBuy-title">保障计划怎么买?</p>
          <p>1、如果您仅患有甲状腺结节、甲亢、甲减，请选择“甲状腺结节版”计划；</p>
          <p>2、如果您仅患有高血压，请选择“高血压版”计划；</p>
          <p>3、如果您仅患有Ⅱ型糖尿病，请选择“糖尿病版”计划；</p>
          <p>4、如果您患有乳腺结节、肾结石、痛风、颈椎病等117种疾病，请选择“其他慢病版”计划。</p>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

// 根api地址，通过环境变量的配置获取
const API_PATH = process.env.VUE_APP_API_URL;
// 初始化接口
const API_WEB_INIT = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/insuranceWebInit.json`;
// 获取验证码，前置校验接口，是否需要滑块验证
const API_CHECK_SMS_CODE = `${API_PATH}/mapi/user/userBase/baseAPI/checkSmsCode.json`;
// 滑块初始化注册
const API_SMS_REGISTER = `${API_PATH}/mapi/user/userBase/baseAPI/smsRegister.json`;
// 滑块二次校验
const API_SMS_CODE = `${API_PATH}/mapi/user/userBase/baseAPI/smsCode.json`;
// 短信验证及投保人账号信息查询
const API_USER_QUERY = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/insuranceWebUserQuery.json`;
// 保费试算
const API_INS_CAL_PRICE = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/insuranceCalcPrice.json`;
// 立即投保注册
const API_INS_WEB_REGISTER = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/insuranceWebRegist.json`;
// 组装下单所需参数接口
const API_INS_CALC_GENERATE = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/insuranceCalcGenerate.json`;
// 加购责任提示接口
const API_INS_DUTY_MESS = `${API_PATH}/mapi/insurance/insuranceBase/baseAPI/insuranceDutyMessage.json`;
// 埋点线索上报接口
const OPENAPI_REPORT_POINT = `${API_PATH}/openapi/channel/collectionClues.json`;

const regPhone = /^(1[3-9])\d{9}$/; // 检测手机号

import base from '../mixins/base';
import loadScript from '../utils/loadScript';
import scrollPosition from '../utils/scroll-position';
import Activity from '@/views/product-detail-comp/activity';
import Claim from '@/views/product-detail-comp/claim';
import Feature from '@/views/product-detail-comp/feature';
import Question from '@/views/product-detail-comp/question';
import InsurePlan from '@/views/product-detail-comp/insure-plan';
import BindCard from '@/views/bind-card';
import VueScrollTo from 'vue-scrollto';
import consultQuestion from "./consultQuestion";
export default {
  name: 'ProductDetail',
  mixins: [base, scrollPosition],
  data() {
    return {
      name: '',
      fontSize: parseFloat(document.querySelector('html').style.fontSize),
      headerHeight: 0,
      zIndex200: 200,
      zIndex100: 100,
      zIndex92: 92,
      insuranceId: '',
      pageId: '',
      insurantId: '',
      isFixedTab: false,
      introTabOffsetTop: 0, // tab悬浮条
      featureTop: 0,
      claimTop: 0,
      orderFormTop: 0,
      activityInfo: [], // 活动运营位
      introTabList: [{
        name: '立即投保',
        el: 'orderFormEl',
        active: true
      },{
        name: '产品特色',
        el: 'featureEl',
        active: false
      }, {
        name: '理赔说明',
        el: 'claimEl',
        active: false
      }],
      phone: '',
      showSmsCodeItem: true,
      smsCode: '',
      getCodeText: '获取验证码',
      onGetCode: false,
      applicant: { // 投保人信息
        userId: '',
        realName: '',
        idCardNo: '',
        phone: '',
        messageIsModify: '1', // 证件是否可修改，1：可改，2：不可改
        isIdentify: '1', // 是否为身份证类型，1：是，2：否
        birthDay: '',
        sex: ''
      },
      insurant: { // 被保人信息
        realName: '',
        relation: '1',
        hasSocialSecurity: '1',
        idCardNo: '',
      },
      detailData: {}, // 初始化时返回的数据
      isAgreeAllProtocol: false, // 是否已同意阅读了协议
      insPlanId: '', // 当前计划id
      insDutyIds: [], // 加购责任id
      insuranceDutyDisplays: [], //加购责任列表
      tmpPayItem: {},
      paymentType: 2, // 缴费方式，2：月缴；5：年缴
      payModeMonth: {}, // 月缴对象信息
      payModeYear: {}, // 年缴对象信息
      payChannel: 0, // 扣款方式
      payChannelObj: {}, // 扣款方式对象
      autoRenewal: false, // 开启自动缴费 1:开启；2：未开启
      bindCardPopup: false,
      switchOff: false,//不知道怎么选开关
      discountObj: {
        show: false,
        message: '',
        priceStr: '',
        originalPriceStr: '',
      },
      price: '',
      originalPrice: '',
      discount: '',
      insuranceDutyDetail:{},
      isbottomfix:false,
      errorMsg: '',
      intervalTimer: null,
      //isIphonex: true,
      isIphonex: /iphone[\s\S]*OS X/.test(navigator.userAgent),
      showConsultQuestion: false,
      flag: null,
      showCase: false,
      isOldUser: false, //输入手机号及验证码，验证是否是老用户
      showDutyPop: false, //加购责任险弹窗,
      userInfoBool: false, //验证通过后将手机号和姓名带到咨询里面
      userIdBool: false,
      userInfo: {
        //输入验证码返回的信息,传到挽回窗口
        realName: null,
        phone: null,
        sex: null
      },
      totalInfo: {
        //不脱敏的信息
        realName: null,
        phone: null
      },
      showPhoneCode: false, //挽留页是否显示验证码
      showGoBack: true, //左上角弹窗，首次点击出现挽留弹窗，第二次直接跳走
      showHouBuyBox:false,
    }
  },
  filters: {
    formatPrice(val) {
      if (val) {
        val = val.toString();
        if (val.split('.').length === 1) {
          return val + '.00';
        } else {
          if (val.split('.')[1].length === 2) {
            return val;
          } else if (val.split('.')[1].length === 1) {
            return val + '0';
          }
        }
      } else {
        return '';
      } 
    }
  },
  computed: {
    myName() {
      return this.$store.state.name;
    },
    idCardNoInputPlaceholder() {
      return this.applicant.isIdentify === '1' ? '请输入本人身份证号': '请输入本人证件号码';
    },
    // 扣款方式列表
    payChannelList() {
      if (this.paymentType === 2) {
        return this.payModeMonth.tiecardTypeList || [];
      } else {
        return this.payModeYear.tiecardTypeList || [];
      }
    },
    bankBindId() {
      return this.$store.state.bankBindId;
    },
    bankCardNo() {
      return this.$store.state.bankCardNo;
    }
  },
  activated() {
    this.setPageScrollPosition('container');
  },
  beforeRouteLeave(to, form, next) {
    this.savePageScrollPosition('container');
    next();
  },
  methods: {
    appointmentTime() {
      // console.log(this.userInfo);
      this.flag = null;
      // this.$dataTrack.track("click_appo_conse_btn", "预约专家咨询按钮");
      if (this.userInfoBool) {
        if (!this.userIdBool) {
          this.userInfo.realName = this.applicant.realName;
          this.userInfo.phone = this.phone;
          this.userInfo.sex = this.applicant.sex;
        }
      } else {
        this.userInfo.realName = null;
        this.userInfo.phone = null;
        this.userInfo.sex = null;
      }
      this.showConsultQuestion = true;
    },
    // 取消咨询
    cancleCommit() {
      // this.$refs.detainmentPopup.hide();
      // this.showConsultQuestion = false;
      if (!this.flag) {
        this.showConsultQuestion = false;
      } else {
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          WeixinJSBridge.call("closeWindow"); //微信
        } else if (ua.indexOf("alipay") != -1) {
          //alert("支付宝客户端");
          AlipayJSBridge.call("closeWebview"); //支付宝 关闭窗口（别名）
          AlipayJSBridge.call("exitApp"); // 支付宝 (退出当前H5应用)
        } else if (ua.indexOf("baidu") != -1) {
          //alert("百度客户端");
          BLightApp.closeWindow(); //百度钱包
        } else {
          window.close();
          // this.$refs.detainmentPopup.hide();
          if (this.$store.state.preRoute) {
            this.$router.go(-1);
          } else {
            window.history.go(-1);
          }
        }
      }
    },
    // 咨询成功
    toastSuccess() {
      this.showToast("恭喜您,提交成功");
      this.showConsultQuestion = false;
    },
    // 获取数据
    async getData() {
      this.showLoading();
      let params = {'insuranceId': this.insuranceId, 'pageId': this.pageId};
      const response = await axios.post(API_WEB_INIT, params);
      this.hideLoading();
      if (response.code === 1) {
        this.detailData = response.data;
        this.activityInfo = this.detailData.activityInfo;
        // 默认缴费方式
        (this.detailData.payModeList || []).forEach((item) => {
          if (item.defaultChoose === 1) {
            this.paymentType = item.payMode;
          }
        });
        // 年缴月缴对象
        (this.detailData.payModeList || []).forEach((item) => {
          if (item.payMode === 2) {
            this.payModeMonth = item;
          }
          if (item.payMode === 5) {
            this.payModeYear = item;
          }
        });
        // 不知道怎么选开关
        if(this.detailData.insPlans.length > 1){
          this.switchOff = true
        }
        // 默认计划,从链接上取，重新排序接口取到的计划数组
        let insPlanId = this.$route.query.insPlanId || '';
        let insPlans = this.detailData.insPlans || [];
        let tmpItem = '';
        for (let i = 0; i < insPlans.length; i++) {
          if (insPlans[i]['insPlanId'] === insPlanId) {
            tmpItem = insPlans[i];
            insPlans.splice(i, 1);
          }
        }
        if (tmpItem !== '') {
          insPlans.unshift(tmpItem);
        }
        this.detailData.insPlans = insPlans;
        // 选中数组的第一个
        this.insPlanId = insPlans[0]['insPlanId'];
        if (this.paymentType === 2) {
          this.payChannel = (this.payModeMonth.tiecardTypeList)[0]['code'];
          this.payChannelObj = (this.payModeMonth.tiecardTypeList)[0];
        } else {
          this.payChannel = (this.payModeYear.tiecardTypeList)[0]['code'];
          this.payChannelObj = (this.payModeYear.tiecardTypeList)[0];
        }
        // 加购责任
        this.insuranceDutyDisplays = this.detailData.insuranceDutyDisplays || [];
      } else if (response.code === 101) {
        let data = response.data;
        if (data.status === 1) {
          window.location.href = data.downWebJumpLink || '';
        }
      } else{
        this.showToast(response.msg);
      }
      // 价格
      this.price = this.detailData.price + '|元起' || '';
      // 元素高度，用于计算滚动吸顶
      this.headerHeight = parseInt(1.09 * this.fontSize);
    },
    // 产品特色 理赔说明 常见问题 定位锚点
    goToAnchor(item) {
      let target = '#' + item.el;
      let containerWrapper = this.$refs.containerWrapper;
      VueScrollTo.scrollTo(target, 500, {container: containerWrapper, easing: 'ease-in', offset: -1.82*this.headerHeight});
    },
    // 页面滚动事件
    scrollHandler(e) {
      setTimeout(() => {
        if (this.isFixedTab) {
          this.introTabOffsetTop = this.$refs.fixPlace.offsetTop;
        } else {
          this.introTabOffsetTop = this.$refs.introTab.offsetTop;
        }
        this.featureTop = this.$refs.featureWrapper.offsetTop || 0;
        this.claimTop = this.$refs.claimWrapper.offsetTop || 0;
        this.orderFormTop = this.$refs.orderFormWrapper.offsetTop || 0;

        let scrollTop = this.$refs.containerWrapper.scrollTop + this.headerHeight;
        //底部立即投保按钮处理
        if(this.$refs.containerWrapper.scrollTop >= 9*this.fontSize){
          this.isbottomfix = true
        }else{
          this.isbottomfix = false
        }
        //悬浮tab
        if (this.introTabOffsetTop !== 0 && scrollTop >= this.introTabOffsetTop) {
          this.isFixedTab = true
        } else {
          this.isFixedTab = false
        }
        scrollTop = Math.ceil((scrollTop+this.headerHeight)*1.0);
        if (scrollTop > this.orderFormTop  && scrollTop <= this.featureTop) {
          this.introTabList.forEach((item) => {item.active = false});
          this.introTabList[0]['active'] = true;
        }
        if (scrollTop >= this.featureTop && scrollTop <= this.claimTop) {
          this.introTabList.forEach((item) => {item.active = false});
          this.introTabList[1]['active'] = true;
        }
        if (scrollTop > this.claimTop) {
          this.introTabList.forEach((item) => {item.active = false});
          this.introTabList[2]['active'] = true;
        }
      }, 100);
    },
    //获取短信验证码
    getSmsCode() {
      if (this.onGetCode) {
        return;
      }
      if (this.getCodeText !== '获取验证码') {
        return;
      }
      if (!regPhone.test(this.phone)) {
        this.onGetCode = false;
        this.showToast('请输入正确的手机号');
        return;
      }
      this.onGetCode = true;
      this.getCodeText = '获取中';
      let params = {
        phone: this.phone,
        source: '8'
      };
      axios.post(API_CHECK_SMS_CODE, params).then((response) => {
        if(response.code === 1) {
          let data = response.data;
          if (typeof data.step != 'undefined' && data.step == 'needcaptcha') {
            // 需要滑块验证
            this.initGeetest()
          } else {
            // 倒计时
            this.countDownTime(data.interval);
          }
        } else {
          this.showToast(response.msg)
          this.onGetCode = false;
          this.getCodeText = '获取验证码';
        }
      }).catch((error) => {
        this.onGetCode = false;
        this.getCodeText = '获取验证码';
        this.showToast('网络异常！');
      });
    },
    // 初始化平安滑块
    initGeetest() {
      let self = this;
      axios.post(API_SMS_REGISTER, {'phone': this.phone, 'source': '8'}).then((result) => {
        loadScript(`${API_PATH}/share/script/services/gt.js`, () => {
          initGeetest({
            gt: result.gt,
            challenge: result.challenge,
            offline: !result.success,
            new_captcha: true,
            api_server:(process.env.VUE_APP_MODE === 'production' ? 'https://captcha-api.pingan.com' : 'https://captcha-api-stg.pingan.com:10530') ,
            product:'bind',
            https:true
          }, function (captchaObj) {
            captchaObj.onReady(function(){
              captchaObj.verify();
            }).onSuccess(function(){
              self.checkSmsCode(captchaObj.getValidate());
            }).onError(function(){
              self.showToast('安全验证组件启动失败，请重试');
            });
            setTimeout(() => {
              self.onGetCode = false;
              self.getCodeText = '获取验证码';
            }, 2000);
          })
        })
      }).catch((error) => {
        this.onGetCode = false;
        this.getCodeText = '获取验证码';
        this.showToast('网络异常！');
      })
    },
    // 二次验证
    checkSmsCode(data) {
      this.onGetCode = true;
      let params = {
        source: '8',
        phone: this.phone,
        challenge: data.geetest_challenge,
        validate: data.geetest_validate,
        seccode: data.geetest_seccode
      };
      axios.post(API_SMS_CODE, params).then((response) => {
        if (response.code === 1) {
          this.countDownTime(response.data.interval);
        } else {
          this.onGetCode = false;
          this.getCodeText = '获取验证码';
          this.showToast(response.msg);
        }
      }).catch((error) => {
        this.showToast('网络异常！');
        this.onGetCode = false;
        this.getCodeText = '获取验证码';
      })
    },
    // 验证码倒计时
    countDownTime(interval) {
      let vm = this;
      let leftTime = interval || 60;
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
      }
      this.intervalTimer = setInterval(() => {
        if (leftTime == 1) {
          vm.getCodeText = '获取验证码';
          clearInterval(vm.intervalTimer);
          vm.onGetCode = false;
          return;
        } else {
          leftTime = leftTime - 1;
          vm.getCodeText = '(' + leftTime + 's)';
        }
      }, 1000);
    },
    onRealNameChange() {
      setTimeout(() => {
        this.calcInsPrice();
      }, 100);
    },
    // 修改老用户返回信息，删除全部清除
    modifyOldUserName(e) {
      if (e.keyCode == 8) {
        if (this.isOldUser) {
          this.applicant.realName = null;
          this.isOldUser = false;
        }
      }
    },
    modifyOldUserId(e) {
      if (e.keyCode == 8) {
        if (this.applicant.idCardNo.includes("*")) {
          this.applicant.idCardNo = null;
        }
      }
    },
    // 监听手机号变化
    onPhoneChange() {
      setTimeout(() => {
        this.userInfoBool = false;
        this.userIdBool = false;
        this.isOldUser = false;
        this.phone=this.phone.replace(/[^\d]/g,'')
        if (this.phone.length !== 11) {
          this.showSmsCodeItem = true;
          this.smsCode = '';
        }
      }, 10);
    },
    // 验证码框失去焦点触发
    onSmsCodeChange() {
      this.userInfoBool = false;
      setTimeout(() => {
        if (this.smsCode.length === 6) {
          if (!regPhone.test(this.phone)) {
            this.showToast('请检查手机号是否正确')
            return;
          } else {
            this.queryUserInfo();
          }
        }
      }, 0);
    },
    // 根据手机号验证码查询用户
    queryUserInfo() {
      if (this.applicant.realName.indexOf('*') >= 0 || this.applicant.idCardNo.indexOf('*') >= 0) {
        this.resetApplicant();
      }
      //this.resetApplicant();
      let params = {
        phone: this.phone,
        smsCode: this.smsCode,
        source: '8'
      };
      axios.post(API_USER_QUERY, params).then((response) => {
        if (response.code === 1) {
          let data = response.data;
          this.userInfoBool = true;
          if (data.userId !== '') { // 此手机号下存在用户
            this.userIdBool = true;
            this.isOldUser = true;
            let applicant = {
              'userId': data.userId,
              'realName': data.userName || this.applicant.realName,
              'idCardNo': data.idCardNo || this.applicant.idCardNo,
              'phone': data.phone,
              'messageIsModify': data.messageIsModify,
              'isIdentify': data.isIdentify,
              'sex': data.sex,
              'birthDay': data.birthDay,
            }
            // 可修改，非身份证，要重置成身份证类型，页面补全
            if (data.messageIsModify === '1' && data.isIdentify === '2') {
              applicant.isIdentify = '1';
              applicant.idCardNo = '';
            }
            this.applicant = applicant;

            this.userInfo.realName = applicant.realName;
            this.userInfo.phone = applicant.phone;
            this.userInfo.sex = applicant.sex;
            this.totalInfo.realName = applicant.realName; //不脱敏的信息
            this.totalInfo.phone = this.phone;
            this.showPhoneCode = true;

          } else {
            this.isOldUser = false;
            this.applicant['messageIsModify'] = data.messageIsModify;
            this.applicant['isIdentify'] = data.isIdentify;
          }
          this.calcInsPrice();
        } else {
          this.userInfoBool = false;
          this.showToast(response.msg);
        }
      }).catch((error) => {
        this.userInfoBool = false;
        this.isOldUser = false;
        this.showToast('网络异常！');
      })
    },
    // 重置投保人信息
    resetApplicant() {
      this.applicant = { // 投保人信息
        userId: '',
        realName: '',
        idCardNo: '',
        phone: '',
        messageIsModify: '1', // 证件是否可修改，1：可改，2：不可改
        isIdentify: '1', // 是否为身份证类型，1：是，2：否
        birthDay: '',
        sex: ''
      };
    },
    // 选择被保人关系
    selectInsurant(value) {
      this.insurant.relation = value;
      this.insurant.realName = '';
      this.insurant.idCardNo = '';
      this.calcInsPrice();
    },
    // 监听被保人身份证输入框变化
    onInsurantIdCardNoChange(e) {
      setTimeout(() => {
        let value = e.target.value;
        //if (value.length === 18) {
          this.calcInsPrice();
        //}
      }, 100);
    },
    // 监听投保人身份证输入框变化
    onApplicantIdCardNoChange(e) {
      setTimeout(() => {
        if (this.applicant.isIdentify === '1') {
          let value = e.target.value;
          //if (value.length >= 18) {
            this.calcInsPrice();
          //}
        }  
      }, 100);
    },
    // 选择有无社保
    selectSocialSecurity(val) {
      this.insurant.hasSocialSecurity = val;
      this.calcInsPrice();
    },
    // 跳转到其他页面
    goToThirdPage(e) {
      let url = e.target.getAttribute('data-url');
      let title = e.target.text || '';
      this.$router.push({
        name: 'ThirdPage',
        query: {
          url: url,
          title: title,
        }
      })
    },
    goDetail(n){
      var pid = (n==1)?'87':'85'; //n=1 老年三高版  n=2 e生保2020
      var re_from = this.$store.state.re_from || 'bd_h5';
      var order_from = this.$store.state.order_from || 'bd_h5';
     
      PinganHealth.goDetail(pid,re_from,order_from)
    },
    // 选择缴费方式，月缴/年缴
    selectPayMode(value) {
      this.paymentType = value;
      if (this.paymentType === 2) {
        this.payChannel = (this.payModeMonth.tiecardTypeList)[0]['code'];
        this.payChannelObj = (this.payModeMonth.tiecardTypeList)[0];
      } else {
        this.payChannel = (this.payModeYear.tiecardTypeList)[0]['code'];
        this.payChannelObj = (this.payModeYear.tiecardTypeList)[0];
      }
      this.calcInsPrice()
    },
    // 支付方式弹窗
    showPayChannelPopup() {
      this.$refs.selPayChannelPopup.show();
    },
    // 选中某支付方式
    selectPayChannel(item) {
      if (item.code === 3) { // 绑卡
        if (!this.bankCardNo) {
          this.tmpPayItem = item;
          if (!this.applicant.realName || !this.applicant.idCardNo || !this.phone) {
            this.showToast('请录入投保人信息')
            return;
          }
          this.bindCardPopup=true;
        } else {
          this.payChannel = 3;
          this.payChannelObj = item;
          this.hidePayChannelPopup();
        }
      } else {
        this.payChannel = item.code;
        this.payChannelObj = item;
        this.hidePayChannelPopup();
      }
    },
    closeBindCardPopup() {
      this.bindCardPopup = false;
    },
    bindCardSuccess() {
      this.bindCardPopup = false;
      this.$refs.selPayChannelPopup.hide();
      this.payChannel = this.tmpPayItem.code;
      this.payChannelObj = this.tmpPayItem;
    },
    // 关闭 选择支付方式弹窗
    hidePayChannelPopup() {
      this.$refs.selPayChannelPopup.hide();
    },
    // 选择计划
    selectInsPlan(insPlanId) {
      this.insPlanId = insPlanId;
      this.calcInsPrice();
    },
    // 选择加购责任
    selectInsDuty(dutyId) {
      if (!this.insDutyIds.includes(dutyId)) {
        this.insDutyIds.push(dutyId)
      } else {
        this.insDutyIds = this.insDutyIds.filter(item => item != dutyId);
      }
      this.calcInsPrice();
    },
    // 保费试算
    async calcInsPrice() {
      this.showLoading();
      this.applicant.phone = this.phone;
      let insurants = [];
      insurants.push(this.insurant);
      let params = {
        insId: this.insuranceId,
        insPlanId: this.insPlanId,
        paymentType: this.paymentType,
        dutyIds: this.insDutyIds.join('|'),
        applicant: JSON.stringify(this.applicant),
        insurants: JSON.stringify(insurants)
      };
      const response = await axios.post(API_INS_CAL_PRICE, params);
      this.hideLoading();
      if (response.code === 1 && response.data) {
        let data = response.data;
        this.insuranceDutyDisplays = data.insuranceDutyDisplays || [];
        if (data.priceStr && data.originalPriceStr) { // 有信用折扣
          this.discountObj = {
            show: true,
            message: data.hrcDiscountMessage.message,
            priceStr: data.priceStr,
            originalPriceStr: data.originalPriceStr,
          }
        } else { // 无信用折扣
          this.discountObj = {
            show: false,
            message: '',
            priceStr: '',
            originalPriceStr: ''
          };
        }
        this.price = data.price;
        this.originalPrice = data.originalPrice;
        this.discount = data.discount;
        this.errorMsg = '';
      } else {
        this.price = '';
        this.originalPrice = '';
        this.discount = '';
        this.errorMsg = response.msg;
        this.showToast(response.msg);
      }
    },
    // 点击 立即投保 按钮注册时
    onInsRegister() {
      this.applicant.phone = this.phone;
      if(!this.applicant.phone || !this.applicant.realName || !this.applicant.idCardNo) {
        this.showToast('请录入投保人信息')
        this.goToAnchor(this.introTabList[0]);
        return;
      }
      if (this.insurant.relation !== '1') {
        if (!this.insurant.realName || !this.insurant.idCardNo) {
          this.showToast('请录入被保人信息')
          this.goToAnchor(this.introTabList[0]);
          return;
        }
      }
      if (!this.price || this.price.indexOf('起') >= 0) {
        this.showToast(this.errorMsg || '请检查您填写的信息是否正确');
        return;
      }
      // 月缴|银行卡
      if (this.paymentType === 2 && this.payChannel === 3) {
        if (!this.bankBindId || !this.bankCardNo) {
          this.showPayChannelPopup();
          return;
        }
      }
      if (this.paymentType === 5 && this.autoRenewal) {
        if (this.payChannel === 3 && (!this.bankBindId || !this.bankCardNo)) {
          this.showPayChannelPopup();
          return;
        }
      }
      if (!this.isAgreeAllProtocol) {
        this.$refs.agreeProtocolPopup.show();
        return;
      }
      this.goInsRegister();
    },
    // 请求注册
    async goInsRegister() {
      this.hideAgreeProtocolPopup();
      let insurants = []
      insurants.push(this.insurant);
      let params = {
        applicant: JSON.stringify(this.applicant),
        insurants: JSON.stringify(insurants),
        paymentType: this.paymentType,
        payChannel: this.payChannel,
        payChannelId: this.payChannel === 3 ? this.bankBindId : this.$store.state.userId,
        channel: this.$store.state.re_from || 'bd_h5'
      };
      this.showLoading();
      const response = await axios.post(API_INS_WEB_REGISTER, params);
      this.hideLoading();
      if (response.code === 1) {
        let data = response.data;
        this.insurantId = data.insurantId;
        this.$store.commit('accessToken', data.accessToken);
        this.$store.commit('userId', data.userId);
        this.insCalcGenerate();
        this.reportAPIPoint(data);
      } else if(response.code === 2513) {
        this.showSmsCodeItem = true;
        this.smsCode = '';
        this.showToast(response.msg);
      } else {
        this.showToast(response.msg);
      }
    },
    //上报API线索埋点
    reportAPIPoint(data){
      let query = this.$route.query;
      let pointParams = {
        userId:data.userId,
        isNewUser: data.isReg == 1 ? 1 : 2
      }
      let advertConfigId = query.advertConfigId || '';
      if(advertConfigId){
        pointParams.advertConfigId = advertConfigId;
        if(advertConfigId == 3){
            // 头条
            pointParams.adPlanId = query.adid || '';
            pointParams.adIdeaId = query.creativeid || '';
            pointParams.clickId = query.clickid || '';
            pointParams.creativeType = query.creativetype || '';
            pointParams.link = encodeURIComponent(window.location.href);
        }else if(advertConfigId == 5){
            // 广点通
            pointParams.clickId = query.qz_gdt || '';
            pointParams.link = encodeURIComponent(window.location.href.split('?')[0]);
        }else if(advertConfigId == 6){
            // 百度
            pointParams.clickId = query.bd_vid || '';
            pointParams.sourceType = query.sourceType || '';
            pointParams.link = window.location.href;
        }else if(advertConfigId == 4){
            // 快手
            pointParams.clickId = query.callback || '';
            pointParams.link = window.location.href;
        }else if(advertConfigId == 7){
            // 微信
            pointParams.clickId = query.gdt_vid || '';
            pointParams.link = encodeURIComponent(window.location.href.split('?')[0]);
        }else if(advertConfigId == 8){
            // uc
            pointParams.clickId = query.uctrackid || '';
	          pointParams.link = window.location.href;
        }else{
            return;
        }
        axios.post(OPENAPI_REPORT_POINT,pointParams).then((response) => {
          console.log(response);
        })
      }
    },
    // 关闭同意协议内容弹窗
    hideAgreeProtocolPopup() {
      this.$refs.agreeProtocolPopup.hide();
    },
    // 点击立即投保时请求下单所需参数
    async insCalcGenerate() {
      let params = {
        insId: this.insuranceId,
        insPlanId: this.insPlanId,
        paymentType: this.paymentType,
        dutyIds: this.insDutyIds.join('|'),
      };
      this.showLoading();
      const response = await axios.post(API_INS_CALC_GENERATE, params);
      if (response.code === 1) {
        let data = response.data;
        this.setPlaceOrderParams(data);
        this.hideLoading();
        this.goToHealthNotice();
      } else {
        this.hideLoading();
        this.showToast(response.msg);
      }
    },
    // 组装下单所需参数,健康告知页用
    setPlaceOrderParams(data) {
      let insurants = []
      let insurantItem = {
        insurantId: this.insurantId,
        insurantIsSelf: this.insurant.relation === '1' ? 1 : 2
      };
      insurants.push(insurantItem);
      let params = {
        insurants: JSON.stringify(insurants),
        insuranceId: this.insuranceId,
        planId: data.insPlanId,
        period: data.period,
        userId: this.$store.state.userId,
        accessToken: this.$store.state.accessToken,
        orderType: 1,
        shareCoverage: 2,
        paymentMoney: this.price,
        insuranceScheme: JSON.stringify(data.insuranceScheme),
        payMode: this.paymentType,
        autoRenewal: this.paymentType === 2 ? 1 : (this.autoRenewal === true ? 1 : 2),
        payChannel: this.payChannel,
        payChannelId: this.payChannel === 3 ? this.bankBindId : 0, // 微信月缴时
        discount: this.discount,
        originalPrice: this.originalPrice,
        sceneCode: '1',
        hasSocialSecurity: this.insurant.hasSocialSecurity,
        channel: this.$store.state.order_from || 'bd_h5',
      };
      this.$cookie.delete('placeOrderParams');
      this.$cookie.set('placeOrderParams', JSON.stringify(params), {expires: '1h'});
    },
    // 跳转到健康告知页
    goToHealthNotice() {
      this.showSmsCodeItem = false;
      this.smsCode = '';
      this.$router.push({
        name: 'HealthNotice',
        query: {
          planId: this.insPlanId,
          insId: this.insuranceId,
          pageId: this.pageId,
        }
      })
    },
    // 返回弹出挽留弹框
    detainmentShow() {
      this.flag = "back";
      this.showConsultQuestion = true;
    },
    // 返回弹出挽留弹框
    // leaveNO() {
    //   let ua = navigator.userAgent.toLowerCase(); 
    //   if(ua.match(/MicroMessenger/i)=="micromessenger") { 
    //     WeixinJSBridge.call('closeWindow');//微信 
    //   } else if(ua.indexOf("alipay")!=-1){ 
    //     //alert("支付宝客户端"); 
    //     AlipayJSBridge.call('closeWebview'); //支付宝 关闭窗口（别名）
    //     AlipayJSBridge.call('exitApp'); // 支付宝 (退出当前H5应用)
    //   }else if(ua.indexOf("baidu")!=-1){ 
    //     //alert("百度客户端");
    //     BLightApp.closeWindow();//百度钱包 
    //   }else{
    //     window.close()
    //     this.$refs.detainmentPopup.hide();
    //     if (this.$store.state.preRoute) {
    //       this.$router.go(-1);
    //     } else {
    //       window.history.go(-1);
    //     } 
    //   }
    // },
    lookDutyDetail(dutyId,title,agerange){
      let self = this;
      self.showLoading();
      let params = {"dutyId":dutyId};
      axios.post(API_INS_DUTY_MESS, params).then((response) => {
        self.hideLoading();
        if(response.code === 1) {
          self.$refs.dutyPopup.show();
          self.insuranceDutyDetail = response.data||'';
          self.insuranceDutyDetail.title=title;
          self.insuranceDutyDetail.agerange=agerange;
        } else {
          self.showToast(response.msg)
        }
      }).catch((error) => {
        self.showToast('网络异常！');
      });
    },
    closeDutyPopup(){
      this.$refs.dutyPopup.hide();
    }
   
  },
  updated() {
  },
  mounted() {
    let self = this;
    let origin = window.location.origin;
    this.$cookie.set('p-share-link', encodeURI(window.location.href));
    let shareConfig = {
      //分享标题
      title:"i康保·百万医疗（慢病版）",
      //分享图片地址
      imgUrl:origin+'/share/statics/images/product/101.png',
      //分享链接地址
      linkUrl: this.$cookie.get('p-share-link'),
      //分享描述文案
      description:"最高报销400万各类医疗费 指定慢病既往症也能保 保费最高优惠30%"
    }
    PinganHealth.wxShare(shareConfig);
  },
  created() {
    // 从url上获取动态参数
    let query = this.$route.query;
    this.insuranceId = query.insid;
    this.pageId = query.pid;
    let re_from = query.re_from || 'bd_h5';
    let order_from = query.order_from || 'bd_h5';
    this.$store.commit('re_from', re_from);
    this.$store.commit('order_from', order_from);
    this.getData();
    // http://localhost:9001/promotion/?insid=101&pid=10
  },
  components: {
    Activity,
    Claim,
    Feature,
    Question,
    InsurePlan,
    BindCard,
    consultQuestion
  }
}
</script>

<style scoped lang="stylus">
  .view-product-detail
    width: 100%
    height: 100%
    .header
      width: 100%
      height: 1rem
      line-height: 1rem
      background-color: #fff
      color: #333
      text-align: center
      font-size: .34rem
      position: absolute
      top: 0
      left: 0
      display: flex
      z-index: 80
      border-bottom: 1px solid #f5f5f5
      .back-btn
        position: absolute
        top: .3rem
        left: .3rem
        width: .38rem
        height: .38rem
        img
          display: block
          width: 100%
          height: 100%  
      .title
        width: 100%
        text-align: center 
    .container
      width: 100%
      height: 100%
      overflow-y: scroll
      padding-top: 1rem
      background-color: #f5f5f5
      position: relative   
      .banner
        width: 100%
        height: 9rem
        text-align: center
        .head-image
          width: 100%
          height: 100%
          position: relative
          display: flex
          justify-content: center
          img
            display: block
            height: 100%
            width: 100%
          .btnBox
            position: absolute
            width:4.78rem
            bottom: 1.02rem
            display:block
      .intro
        width: 100%
        height: 1.09rem;
        background-color: #fff
        margin-top: .2rem
        border-bottom: 1px solid #f5f5f5
        ul
          display: flex
          width: 100%
          height: 100%
          li
            flex: 1
            display: flex
            justify-content: center
            align-items: center
            font-size: .3rem
            color: #666
            &.active
              color: #FF6600
              font-size: .32rem
              font-weight: 500
        &.isFixed
          position: fixed
          top: 1rem;
          left: 0;
          width: 100%
          height: 1.09rem;
          right: 0
          margin-top: 0
          z-index: 80
      .fixPlace
        height: 1.09rem
        margin-top: .2rem
      .order-form
        background-color: #fff
        padding: 0 .3rem
        .order-title
          display: flex
          height: 1.16rem
          align-items: center
          text-align: left
          font-size: .34rem
          color: #333
          font-weight: 500
        .step-organs
          display: flex
          justify-content: space-between
          align-items: center
          .sel-organs
            select
              border: 0
              appearance: none
              padding-left: 1rem
              background: #fff
              background: url("../assets/images/icon-right-arrow.png") no-repeat right center;
              background-size: .14rem
              padding-right: .3rem
              font-size: .28rem
              color: #333
        .step-auto-renewal
          display: flex
          justify-content: space-between
          align-items: center
          margin-bottom: .23rem
          .sel-switch
            color: #FF6600
        .step-item
          padding-bottom: .53rem
          .step-title
            height: .42rem
            display: flex
            align-items: center
            em
              font-style: normal
              width: .36rem
              height: .36rem
              background-color: #FF6600
              border-radius: 100%
              line-height: .36rem
              font-size: .28rem
              display: flex
              justify-content: center
              align-items: center
              color: #fff
            span
              margin-left: .1rem
              color: #333
              font-size: .3rem
              font-weight: 500
            .howBuy
              flex:1
              font-size: .28rem
              font-weight:500
              color: #FF6600
              text-align:right
            label
              font-size: .3rem
              color: #999
              margin-left: .1rem
            img
              height: .3rem
              width: .3rem
              margin-left: .1rem
          .step-disc
            font-size:.26rem;
            font-weight:400;
            color: #FF6600
            span
              color: #4A90E2
          .input-item
            height: 1.27rem
            display: flex
            border-bottom: 1px solid #f5f5f5
            align-items: center
            position: relative
            font-size: .3rem
            span
              width: 1.86rem
              font-size: .3rem
              color: #333
            input
              flex: 1
              font-size: .3rem
              border: none
              color: #333
            .disabled-label
              color: #999
            ::-webkit-input-placeholder {
              color: #999
            }
            input:disabled
              background: #fff
              color: #999
            .get-code
              position: absolute
              right: 1px
              top: .34rem
              width: 1.75rem
              height: .6rem
              text-align: center
              line-height: .6rem
              font-size: .26rem
              color: #FF6600
              background: url('../assets/images/icon-rect.png') no-repeat
              background-size: 100% 100%
              &.disabled
                opacity: .6       
            .sel-social-security
              display: flex
              .sel-option
                padding: 0 .3rem
                height: .7rem
                text-align: center
                line-height: .7rem
                border-radius: .1rem
                background-color: #f5f5f5
                font-size: .28rem
                color: #999
                margin-right: .2rem
                &.active
                  color: #fff
                  background:linear-gradient(90deg,rgba(255,102,0,1) 0%,rgba(254,147,25,1) 100%);
          .sel-insurants
            margin-top: .36rem
            ul
              display: flex
              justify-content: space-between
              li
                width: 1.57rem
                height: .7rem
                text-align: center
                line-height: .7rem
                border-radius: .1rem
                background-color: #f5f5f5
                font-size: .28rem
                color: #999
                &.active
                  color: #fff
                  background:linear-gradient(90deg,rgba(255,102,0,1) 0%,rgba(254,147,25,1) 100%);
          .sel-plan
            margin-top: .35rem
            ul
              display: flex
              justify-content: space-between
              flex-wrap: wrap
              li
                width: 3.35rem
                height: .9rem
                background: #f5f5f5
                color: #999
                line-height: .9rem
                text-align: center
                border-radius: .08rem
                font-size: .3rem
                margin-bottom: .2rem
                &.active
                  color: #fff
                  background:linear-gradient(90deg,rgba(255,102,0,1) 0%,rgba(254,147,25,1) 100%);
          .duty-list
            .duty-item
              border-bottom: 1px solid #f5f5f5
              padding: .35rem 0
              display: flex
              justify-content: space-between
              .duty-base-info
                width: 4.6rem
                .duty-title
                  font-size: .3rem
                  color: #333
                  font-weight: 500
                  height: .42rem
                  display: flex
                  align-items: center
                  img
                    width: .3rem
                    height: .3rem
                    margin-left: .1rem
                .age-range
                  margin-top: .1rem
                  span
                    background-color: #f5f5f5
                    border-radius: .2rem
                    font-size: .24rem
                    color: #666
                    padding: 0 .13rem
                    height: .4rem
                    line-height: .4rem
                .limit-desc
                  margin-top: .1rem
                  height: .37rem
                  line-height: .37rem
                  font-size: .26rem
                  color: #999
              .duty-price
                display: flex
                align-items: center
                color: #FF6600
                span
                  font-size: .36rem
                  font-weight: 500
                label
                  font-size: .28rem
                  margin-left: .1rem
              .duty-sel
                display: flex
                align-items: center
                img
                  height: .4rem
                  width: .4rem
          .sel-pay-mode
            margin-top: .34rem
            ul
              display: flex
              justify-content: space-between
              flex-wrap: wrap
              li
                width: 3.35rem
                background: #f5f5f5
                color: #999
                line-height: 0.38rem
                text-align: center
                border-radius: 0.08rem
                font-size: 0.28rem
                padding: .3rem 0
                &.active
                  color: #fff
                  background:linear-gradient(90deg,rgba(255,102,0,1) 0%,rgba(254,147,25,1) 100%);
          .mode-description
            margin-top: .33rem
            .desc-tips
              margin-top: .26rem
              li
                line-height: .37rem
                font-size: .26rem
                color: #666
                margin-bottom: .11rem
                em
                  margin-right: .1rem
          .auto-renewal-desc
            margin-top: .2rem
            ul
              li
                font-size: .26rem
                color: #666
                line-height: .4rem
                em
                  margin-right: .1rem
        .step-item-pd
          padding-bottom: .3rem
        .selected-mode
          display: flex
          height: .42rem
          align-items: center
          justify-content: space-between
          .name
            color: #333
            font-size: .3rem
            line-height: .42rem
          .mode-value
            display: flex
            align-items: center 
            .icon
              height: .32rem
              width: .32rem
              margin-right: .08rem
            .text
              color: #333
              font-size: .28rem
              margin-right: .08rem
            .arrow
              height: .22rem
              width: .15rem
            img
              display: block
              //width: 100%
              height: 100%
        .step-item-mt-2
          padding-bottom: 0.33rem
      .protocol
        padding: .25rem .3rem 2.2rem .3rem
        .agree
          line-height: .37rem
          font-size: .26rem
          img
            width: .34rem
            height: .34rem
            vertical-align: middle
            margin-top: -3px
          a
            color: #4A90E2
          span
            color: #999
            margin: 0 5px
        .desc
          font-size: .24rem
          color: #999
          line-height: .33rem
          margin-top: .09rem
      .discount-bar
        position: fixed
        left: 0
        right: 0
        bottom: 1.04rem
        background: rgb(253,241,231)
        color: #FF6600
        padding: .13rem .3rem
        line-height: .37rem
        font-size: .26rem
      .bottom-fixed
        display: flex
        height: 1.04rem
        background-color: #fff
        position: fixed
        bottom: 0
        left: 0
        right: 0
        width: 100%
        align-items: center
        padding: 0 .3rem
        justify-content: space-between
        &.is-iphonex
          bottom: .2rem;
        .price
          color: #FF6600
          span
            font-size: .57rem
          label
            font-size: .28rem
            color: #333
            margin-left: .06rem
          i
            font-size: .34rem
            color: #F60
            font-style: normal
            font-weight: 500
            margin-left: .06rem
        .discount-price
          .current-price-str
            height: .5rem;
            line-height: .5rem
            span
              font-size: .36rem
              font-weight: 500
              color: #FF6600
            label
              font-size: .28rem
              color: #333
              margin-left: .06rem
          .original-price-str
            height: .33rem
            line-height: .33rem
            color: #999
            font-size: .24rem
            text-decoration: line-through
        .button
          width: 2.7rem
          height: .8rem
          font-size: .3rem
          display: flex
          align-items: center
          justify-content: center
          color: #fff
          border-radius: .44rem
          background:linear-gradient(90deg,rgba(240,77,22,1) 0%,rgba(254,146,25,1) 100%)
      // .bottom-fixed-true
      //   display: flex
    .sel-pay-mode-content
      background-color: #fff
      width: 100%
      height: 6.58rem
      padding: .23rem .3rem .2rem .3rem
      position: relative
      .title
        height: .45rem
        line-height: .45rem
        font-size: .32rem
        color: #333
        text-align: center
      .pay-mode-list
        margin-top: .42rem
        ul
          li
            display: flex
            justify-content: space-between
            align-items: center
            margin-bottom: .3rem
            .icon
              width: .6rem
              height: .6rem
            img
              display: block
              width: 100%
              height: 100%
            .cont-wechat
              flex: 1
              margin-left: .26rem
              display: flex
              align-items: center
              span
                font-size: .28rem
                color: #1e1e1e
            .cont-bank-card
              flex: 1
              margin-left: .26rem
              .name
                color: #1e1e1e
                font-size: .28rem
                height: .4rem
                line-height: .4rem
                display: flex
                align-items: center
              .desc
                font-size: .24rem
                color: #999
                margin-top: .03rem
                height: .33rem
                line-height: .33rem
            .rec-tag
              width: .7rem
              height: .32rem
              font-size: .22rem
              color: #FF6600
              border: 1px solid #FF6600
              border-radius: .04rem
              text-align: center
              display: flex
              align-items: center
              justify-content: center
              margin-left: .1rem
            .arrow
              width: .18rem
              height: .23rem
      .cancel-btn
        width: 6.9rem
        height: .88rem
        margin: 0 auto
        position: absolute
        bottom: .2rem
        display: flex
        align-items: center
        justify-content: center
        font-size: .32rem
        color: #fff
        border-radius: .44rem
        background:linear-gradient(90deg,rgba(240,77,22,1) 0%,rgba(254,146,25,1) 100%)
    .protocol-content
      background-color: #f5f5f5
      width: 100%
      height: 8.58rem
      overflow-y: scroll
      max-height: 90%
      iframe
        width: 100%
        height: 100%
        border: none
    .agree-content
      background-color: #fff
      width: 6.3rem
      position: relative
      border-radius: .1rem
      padding-bottom: .5rem
      .image
        width: 100%
        height: 3.68rem
        img
          display: block
          width: 100%
          height: 100%
      .protocol-value
        margin: 0 .3rem
        margin-top: .32rem
        line-height: .37rem
        color: #999
        font-size: .26rem
        a
          color: #4A90E2
      .agree-btn
        width: 3.6rem
        height: .8rem
        margin: .45rem auto 0 auto
        border-radius: .44rem
        background:linear-gradient(90deg,rgba(255,102,0,1) 0%,rgba(254,147,25,1) 100%);
        color: #fff
        font-size: .3rem
        display: flex
        align-items: center
        justify-content: center
    .close-popup
      width: .54rem
      height: .54rem
      margin: .5rem auto
      img
        display: block
        width: 100%
        height: 100%
  .detainment-inner
    width: 5.54rem
    height: 6.71rem
    background-color: rgba(0,0,0,0)
    font-weight: 400
    text-align: center
    font-size:.28rem
    color:#333333
    background: url('../assets/images/wanliu.png') no-repeat
    background-size: 100% 100%
    .content-box
      padding-top: 3.34rem
      text-align: center
      p
        line-height: .4rem
        color: #029279
        span
          color:#FE7B17
          font-weight: 500
    .continue-ok
      width: 2.7rem
      height: .7rem
      display: flex
      align-items: center
      justify-content: center
      background:linear-gradient(180deg,rgba(255,176,71,1) 0%,rgba(254,106,7,1) 100%)
      border-radius: .35rem
      color: #fff
      margin: 0 auto
      margin-top: .42rem
      a
        color: #fff
    .leave-no
      width: 2.7rem
      height: .7rem
      display: flex
      align-items: center
      justify-content: center
      border: 1px solid rgba(24,173,133,.5)
      border-radius: .35rem
      color: #18AD85
      margin: 0 auto
      margin-top: .2rem
      a
        color: #18AD85
  .duty-inner
    width: 6.6rem
    background: #fff
    border-radius: .1rem
    font-weight: 400
    text-align: center
    font-size:.28rem
    color:#333333
    padding: .6rem .3rem
    h3
      font-weight: 400;
      margin-bottom: .18rem  
    h4
      font-weight: 400;
      color: #666;
      font-size: .22rem;
      margin-bottom: .25rem
    #jgzr_contentbox
      overflow: auto;
      max-height: 6rem
      font-size: .26rem
      .sub_title
        font-weight: 500;
        margin-bottom: .24rem
      .tips_content 
        text-align: left
        color: #666666
        margin-bottom: .54rem
    .tips_bottom
      a
        width: 2.6rem
        height: .6rem
        border: 1px solid #F60;
        border-radius: .6rem
        text-align: center;
        line-height: .6rem
        display: inline-block;
        color: #F60; 
  .bind-card-content
    z-index: 96
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    width: 7.5rem;
    height: 100%;
    background-color: #fff
    overflow-y: scroll
  #adjusted-protocol
    padding: .25rem .3rem .4rem .3rem
    background: #fff
    border-top: 1px solid #f5f5f5

  .howBuy-box
    width:100%
    height:100%
    position:fixed
    left:0
    top:0
    z-index:210
    display:flex
    align-items:center
    justify-content:center
    .howBuy-mark
      width:100%
      height:100%
      background:#000000
      opacity:0.4
      position:absolute
      left:0
      top:0
    .howBuy-cont
      width:6.3rem
      padding:.44rem .4rem
      background:#fff
      border-radius:.12rem
      z-index:220
      position:relative
      i
        position:absolute
        right:.31rem
        top:.31rem
        display:inline-block
        width:.25rem
        height:.25rem
        background-image:url("../assets/images/close.png") 
        background-size: 100% 100%;
        
      .howBuy-title
        height:.45rem
        margin-bottom:.28rem
        font-size:.32rem
        font-weight:500;
        color:#333;
        line-height:.45rem;
        text-align:center
      p
        font-size:.28rem
        font-weight:400
        color:#333;
</style>
